import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modern-breadcrumbs"},[_c(VBreadcrumbs,{staticClass:"breadcrumb-list pa-0 mb-3",attrs:{"items":_vm.routelinks,"divider":"›"},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"breadcrumb-item",class:{ 'breadcrumb-item--active': item.disabled }},[_vm._v(_vm._s(item.text))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }